import { moduleStatus } from '@/domain/enums/module';
import translate from '@/services/translate';

const moduleStatusOptions = () => [
  {
    id: moduleStatus.ACTIVE,
    name: translate('enums.module-status.active'),
  },
  {
    id: moduleStatus.INACTIVE,
    name: translate('enums.module-status.inactive'),
  },
  {
    id: moduleStatus.DISABLED,
    name: translate('enums.module-status.disabled'),
  },
  {
    id: moduleStatus.ESTABLISHING_COMMUNICATION,
    name: translate('enums.module-status.establishing-communication'),
  },
  {
    id: moduleStatus.UNDER_MAINTENANCE,
    name: translate('enums.module-status.under-maintenance'),
  },
  {
    id: moduleStatus.SIMULATION,
    name: translate('enums.module-status.simulation'),
  },
  {
    id: moduleStatus.INDETERMINATE,
    name: translate('enums.module-status.indeterminate'),
  },
  {
    id: moduleStatus.PARTIAL_COMMUNICATION,
    name: translate('enums.module-status.partial-communication'),
  },
];
export default moduleStatusOptions;
